module.exports = __webpack_public_path__ + "static/ivana_bilic-728f6b2cc0e532a22084ebe6b4c3fe6e.png";